export const ROLE_EMPLOYEE = 'EMPLOYEE'
export const ROLE_FLEET_MGR = 'FLEET_MGR'
